/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ShipmentState } from "./ShipmentState";
import {
  ShipmentStateFromJSON,
  ShipmentStateFromJSONTyped,
  ShipmentStateToJSON,
  ShipmentStateToJSONTyped,
} from "./ShipmentState";
import type { Broker } from "./Broker";
import {
  BrokerFromJSON,
  BrokerFromJSONTyped,
  BrokerToJSON,
  BrokerToJSONTyped,
} from "./Broker";
import type { CustomsDocsState } from "./CustomsDocsState";
import {
  CustomsDocsStateFromJSON,
  CustomsDocsStateFromJSONTyped,
  CustomsDocsStateToJSON,
  CustomsDocsStateToJSONTyped,
} from "./CustomsDocsState";
import type { InvoiceAuditProblem } from "./InvoiceAuditProblem";
import {
  InvoiceAuditProblemFromJSON,
  InvoiceAuditProblemFromJSONTyped,
  InvoiceAuditProblemToJSON,
  InvoiceAuditProblemToJSONTyped,
} from "./InvoiceAuditProblem";
import type { LineItem } from "./LineItem";
import {
  LineItemFromJSON,
  LineItemFromJSONTyped,
  LineItemToJSON,
  LineItemToJSONTyped,
} from "./LineItem";
import type { EquipmentType } from "./EquipmentType";
import {
  EquipmentTypeFromJSON,
  EquipmentTypeFromJSONTyped,
  EquipmentTypeToJSON,
  EquipmentTypeToJSONTyped,
} from "./EquipmentType";
import type { Source } from "./Source";
import {
  SourceFromJSON,
  SourceFromJSONTyped,
  SourceToJSON,
  SourceToJSONTyped,
} from "./Source";
import type { Contact } from "./Contact";
import {
  ContactFromJSON,
  ContactFromJSONTyped,
  ContactToJSON,
  ContactToJSONTyped,
} from "./Contact";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { LoadingCapabilitiesAvailability } from "./LoadingCapabilitiesAvailability";
import {
  LoadingCapabilitiesAvailabilityFromJSON,
  LoadingCapabilitiesAvailabilityFromJSONTyped,
  LoadingCapabilitiesAvailabilityToJSON,
  LoadingCapabilitiesAvailabilityToJSONTyped,
} from "./LoadingCapabilitiesAvailability";
import type { ConversationTurn } from "./ConversationTurn";
import {
  ConversationTurnFromJSON,
  ConversationTurnFromJSONTyped,
  ConversationTurnToJSON,
  ConversationTurnToJSONTyped,
} from "./ConversationTurn";
import type { ShipmentPickupBookingMethod } from "./ShipmentPickupBookingMethod";
import {
  ShipmentPickupBookingMethodFromJSON,
  ShipmentPickupBookingMethodFromJSONTyped,
  ShipmentPickupBookingMethodToJSON,
  ShipmentPickupBookingMethodToJSONTyped,
} from "./ShipmentPickupBookingMethod";
import type { StateOfGoodsEnum } from "./StateOfGoodsEnum";
import {
  StateOfGoodsEnumFromJSON,
  StateOfGoodsEnumFromJSONTyped,
  StateOfGoodsEnumToJSON,
  StateOfGoodsEnumToJSONTyped,
} from "./StateOfGoodsEnum";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";

/**
 *
 * @export
 * @interface Shipment
 */
export interface Shipment {
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  shipmentId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  createdBy?: string;
  /**
   *
   * @type {ShipmentState}
   * @memberof Shipment
   */
  state?: ShipmentState;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  pickupDate?: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  expectedDeliveryDate?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  expectedDeliveryHours?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  actualDeliveryDate?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  actualDeliveryTime?: string;
  /**
   *
   * @type {Location}
   * @memberof Shipment
   */
  pickupLocation?: Location;
  /**
   *
   * @type {Contact}
   * @memberof Shipment
   */
  pickupContact?: Contact;
  /**
   *
   * @type {Location}
   * @memberof Shipment
   */
  deliveryLocation?: Location;
  /**
   *
   * @type {Contact}
   * @memberof Shipment
   */
  deliveryContact?: Contact;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof Shipment
   */
  lineItems?: Array<LineItem>;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  stripePaymentMethodId?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  selectedQuoteId?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  billOfLadingDocumentId?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  proNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  carrierPickupNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  pickupReferenceNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  deliveryReferenceNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  cancellationRequested?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  deleted?: boolean;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  bookedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  trackingId?: string;
  /**
   *
   * @type {Broker}
   * @memberof Shipment
   */
  broker?: Broker;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  isReviewingPriorToBooking?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  deletionReason?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  emergencyContactName?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  emergencyContactPhoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  emergencyContactPhoneNumberExtension?: string;
  /**
   *
   * @type {CustomsDocsState}
   * @memberof Shipment
   */
  customsDocsState?: CustomsDocsState;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  expectedDeliveryDateFromApi?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  billOfLadingNumber?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof Shipment
   */
  finalizeBookingStages?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  deliveryAppointmentMade?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  deliveryAppointmentHours?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  outForDelivery?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  late?: boolean;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  numberDaysLate?: number;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  originalPickupDate?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  bookedBy?: string;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  totalWeight?: number;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  totalVolume?: number;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  density?: number;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  totalHandlingUnits?: number;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  declaredValue?: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof Shipment
   */
  declaredValueCurrency?: CurrencyCode;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  suggestedTrackingLine?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  expectedDeliveryDateAtPickup?: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  latestPredictedDeliveryDateAtPickup?: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  pauseAmyEmailsUntilDate?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  shipmentHash?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  bookedByPhone?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  bookedByEmail?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  bookedByName?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  quotedByPhone?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  quotedByEmail?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  quotedByName?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  manualQuoting?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  manualQuotingNotes?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  manualQuotingOpen?: boolean;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  standardDryVanLinearFeet?: number;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  freightMissing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  apolloQuotingTriaged?: boolean;
  /**
   *
   * @type {EquipmentType}
   * @memberof Shipment
   */
  equipmentType?: EquipmentType;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  exclusiveUseNeeded?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  addInsuranceToShipment?: boolean;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  insuranceAmount?: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof Shipment
   */
  insuranceCurrency?: CurrencyCode;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  outForDeliveryDate?: LocalDate;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  hotFreight?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  pickupPackageDocumentId?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  appointmentDate?: LocalDate;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  apolloQuotingFlagged?: boolean;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  freightMissingDate?: LocalDate;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  challengeAllInvoices?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  branchId?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  tarpRequired?: boolean;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  deliveryDeadline?: LocalDate;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  carrierInvoicingClosed?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  pickupBoothNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  deliveryBoothNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  isPickupBooked?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  advanceInterlineProNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  advanceInterlineCarrierPickupNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  advanceInterlineCarrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  advanceInterlineCarrierDisplayName?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  beyondInterlineProNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  beyondInterlineCarrierPickupNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  beyondInterlineCarrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  beyondInterlineCarrierDisplayName?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  customDocsDeliveredAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  customDocsSentTo?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  pickupDeadline?: LocalDate;
  /**
   *
   * @type {Array<string>}
   * @memberof Shipment
   */
  problems?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof Shipment
   */
  tags?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  invoiceAuditOpen?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  invoiceAuditAssignee?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  invoiceAuditExisted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  invoiceAuditCustomerFrontConversationId?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  invoiceAuditCarrierFrontConversationId?: string;
  /**
   *
   * @type {ConversationTurn}
   * @memberof Shipment
   */
  invoiceAuditCarrierTurn?: ConversationTurn;
  /**
   *
   * @type {ConversationTurn}
   * @memberof Shipment
   */
  invoiceAuditCustomerTurn?: ConversationTurn;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  invoiceAuditCarrierTurnTime?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  invoiceAuditCustomerTurnTime?: OffsetDateTime;
  /**
   *
   * @type {Array<InvoiceAuditProblem>}
   * @memberof Shipment
   */
  invoiceAuditProblems?: Array<InvoiceAuditProblem>;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  invoiceAuditFirstOpenedDate?: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  invoiceAuditSnoozedUntilDate?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  standardDryVanLinearFeetSvg?: string;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  linearFeetOverride?: number;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  pauseCustomsDocsReminders?: boolean;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  onHoldReason?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  automaticallyFetchTrackingUpdates?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  pickupDayReminderEmailSent?: boolean;
  /**
   *
   * @type {Source}
   * @memberof Shipment
   */
  source?: Source;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  provisionalXeroCarrierInvoiceId?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  missingInvoiceFrontConversationId?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  bannerMessageTitle?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  bannerMessageDescription?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  bannerMessageLastEditedBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  bannerMessageLastEditedAt?: OffsetDateTime;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  pendingCustomsClearance?: boolean;
  /**
   *
   * @type {StateOfGoodsEnum}
   * @memberof Shipment
   */
  stateOfGoods?: StateOfGoodsEnum;
  /**
   *
   * @type {ShipmentPickupBookingMethod}
   * @memberof Shipment
   */
  pickupBookingMethod?: ShipmentPickupBookingMethod;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  bookedAtAssignedTo?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  skipCustomerInvoiceNotification?: boolean;
  /**
   *
   * @type {LoadingCapabilitiesAvailability}
   * @memberof Shipment
   */
  pickupLocationHasDock?: LoadingCapabilitiesAvailability;
  /**
   *
   * @type {LoadingCapabilitiesAvailability}
   * @memberof Shipment
   */
  pickupLocationHasForklift?: LoadingCapabilitiesAvailability;
  /**
   *
   * @type {LoadingCapabilitiesAvailability}
   * @memberof Shipment
   */
  deliveryLocationHasDock?: LoadingCapabilitiesAvailability;
  /**
   *
   * @type {LoadingCapabilitiesAvailability}
   * @memberof Shipment
   */
  deliveryLocationHasForklift?: LoadingCapabilitiesAvailability;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  externalMetadata?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  insuranceCertificate?: string;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  insurancePremiumAmount?: number;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  insurancePremiumTaxesAmount?: number;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  insurancePremiumCurrency?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  insurancePremiumReferralReason?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  insuranceCommodityGroup?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  insuranceCertificateStatus?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  insuranceCertificateCreatedAt?: OffsetDateTime;
  /**
   *
   * @type {number}
   * @memberof Shipment
   */
  bookedShipmentNumber?: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  manualQuotingOpenedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  invoiceAuditClosedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  customsManuallyClearedAt?: OffsetDateTime;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  freightShortage?: boolean;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  freightShortageDate?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  operationsAssignedTo?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  operationsAssignedAt?: OffsetDateTime;
  /**
   *
   * @type {Array<string>}
   * @memberof Shipment
   */
  additionalNotificationEmails?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  freightDamaged?: boolean;
  /**
   *
   * @type {LocalDate}
   * @memberof Shipment
   */
  freightDamagedDate?: LocalDate;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  operatorFlagged?: boolean;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  operatorFlaggedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  operatorFlaggedMessage?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  operatorFlaggedBy?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  operatorFlaggedByDisplayName?: string;
  /**
   *
   * @type {boolean}
   * @memberof Shipment
   */
  customerFlagged?: boolean;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Shipment
   */
  customerFlaggedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  customerFlaggedMessage?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  customerFlaggedBy?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  customerFlaggedByDisplayName?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  erapPlanNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  erapPhoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Shipment
   */
  tdgResponsibleName?: string;
}

/**
 * Check if a given object implements the Shipment interface.
 */
export function instanceOfShipment(value: object): value is Shipment {
  return true;
}

export function ShipmentFromJSON(json: any): Shipment {
  return ShipmentFromJSONTyped(json, false);
}

export function ShipmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Shipment {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    state:
      json["state"] == null ? undefined : ShipmentStateFromJSON(json["state"]),
    pickupDate: json["pickupDate"] == null ? undefined : json["pickupDate"],
    expectedDeliveryDate:
      json["expectedDeliveryDate"] == null
        ? undefined
        : json["expectedDeliveryDate"],
    expectedDeliveryHours:
      json["expectedDeliveryHours"] == null
        ? undefined
        : json["expectedDeliveryHours"],
    actualDeliveryDate:
      json["actualDeliveryDate"] == null
        ? undefined
        : json["actualDeliveryDate"],
    actualDeliveryTime:
      json["actualDeliveryTime"] == null
        ? undefined
        : json["actualDeliveryTime"],
    pickupLocation:
      json["pickupLocation"] == null
        ? undefined
        : LocationFromJSON(json["pickupLocation"]),
    pickupContact:
      json["pickupContact"] == null
        ? undefined
        : ContactFromJSON(json["pickupContact"]),
    deliveryLocation:
      json["deliveryLocation"] == null
        ? undefined
        : LocationFromJSON(json["deliveryLocation"]),
    deliveryContact:
      json["deliveryContact"] == null
        ? undefined
        : ContactFromJSON(json["deliveryContact"]),
    lineItems:
      json["lineItems"] == null
        ? undefined
        : (json["lineItems"] as Array<any>).map(LineItemFromJSON),
    stripePaymentMethodId:
      json["stripePaymentMethodId"] == null
        ? undefined
        : json["stripePaymentMethodId"],
    selectedQuoteId:
      json["selectedQuoteId"] == null ? undefined : json["selectedQuoteId"],
    billOfLadingDocumentId:
      json["billOfLadingDocumentId"] == null
        ? undefined
        : json["billOfLadingDocumentId"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    carrierPickupNumber:
      json["carrierPickupNumber"] == null
        ? undefined
        : json["carrierPickupNumber"],
    pickupReferenceNumber:
      json["pickupReferenceNumber"] == null
        ? undefined
        : json["pickupReferenceNumber"],
    deliveryReferenceNumber:
      json["deliveryReferenceNumber"] == null
        ? undefined
        : json["deliveryReferenceNumber"],
    cancellationRequested:
      json["cancellationRequested"] == null
        ? undefined
        : json["cancellationRequested"],
    deleted: json["deleted"] == null ? undefined : json["deleted"],
    bookedAt: json["bookedAt"] == null ? undefined : json["bookedAt"],
    trackingId: json["trackingId"] == null ? undefined : json["trackingId"],
    broker: json["broker"] == null ? undefined : BrokerFromJSON(json["broker"]),
    isReviewingPriorToBooking:
      json["isReviewingPriorToBooking"] == null
        ? undefined
        : json["isReviewingPriorToBooking"],
    deletionReason:
      json["deletionReason"] == null ? undefined : json["deletionReason"],
    emergencyContactName:
      json["emergencyContactName"] == null
        ? undefined
        : json["emergencyContactName"],
    emergencyContactPhoneNumber:
      json["emergencyContactPhoneNumber"] == null
        ? undefined
        : json["emergencyContactPhoneNumber"],
    emergencyContactPhoneNumberExtension:
      json["emergencyContactPhoneNumberExtension"] == null
        ? undefined
        : json["emergencyContactPhoneNumberExtension"],
    customsDocsState:
      json["customsDocsState"] == null
        ? undefined
        : CustomsDocsStateFromJSON(json["customsDocsState"]),
    expectedDeliveryDateFromApi:
      json["expectedDeliveryDateFromApi"] == null
        ? undefined
        : json["expectedDeliveryDateFromApi"],
    billOfLadingNumber:
      json["billOfLadingNumber"] == null
        ? undefined
        : json["billOfLadingNumber"],
    finalizeBookingStages:
      json["finalizeBookingStages"] == null
        ? undefined
        : json["finalizeBookingStages"],
    deliveryAppointmentMade:
      json["deliveryAppointmentMade"] == null
        ? undefined
        : json["deliveryAppointmentMade"],
    deliveryAppointmentHours:
      json["deliveryAppointmentHours"] == null
        ? undefined
        : json["deliveryAppointmentHours"],
    outForDelivery:
      json["outForDelivery"] == null ? undefined : json["outForDelivery"],
    late: json["late"] == null ? undefined : json["late"],
    numberDaysLate:
      json["numberDaysLate"] == null ? undefined : json["numberDaysLate"],
    originalPickupDate:
      json["originalPickupDate"] == null
        ? undefined
        : json["originalPickupDate"],
    bookedBy: json["bookedBy"] == null ? undefined : json["bookedBy"],
    totalWeight: json["totalWeight"] == null ? undefined : json["totalWeight"],
    totalVolume: json["totalVolume"] == null ? undefined : json["totalVolume"],
    density: json["density"] == null ? undefined : json["density"],
    totalHandlingUnits:
      json["totalHandlingUnits"] == null
        ? undefined
        : json["totalHandlingUnits"],
    declaredValue:
      json["declaredValue"] == null ? undefined : json["declaredValue"],
    declaredValueCurrency:
      json["declaredValueCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["declaredValueCurrency"]),
    suggestedTrackingLine:
      json["suggestedTrackingLine"] == null
        ? undefined
        : json["suggestedTrackingLine"],
    expectedDeliveryDateAtPickup:
      json["expectedDeliveryDateAtPickup"] == null
        ? undefined
        : json["expectedDeliveryDateAtPickup"],
    latestPredictedDeliveryDateAtPickup:
      json["latestPredictedDeliveryDateAtPickup"] == null
        ? undefined
        : json["latestPredictedDeliveryDateAtPickup"],
    pauseAmyEmailsUntilDate:
      json["pauseAmyEmailsUntilDate"] == null
        ? undefined
        : json["pauseAmyEmailsUntilDate"],
    shipmentHash:
      json["shipmentHash"] == null ? undefined : json["shipmentHash"],
    bookedByPhone:
      json["bookedByPhone"] == null ? undefined : json["bookedByPhone"],
    bookedByEmail:
      json["bookedByEmail"] == null ? undefined : json["bookedByEmail"],
    bookedByName:
      json["bookedByName"] == null ? undefined : json["bookedByName"],
    quotedByPhone:
      json["quotedByPhone"] == null ? undefined : json["quotedByPhone"],
    quotedByEmail:
      json["quotedByEmail"] == null ? undefined : json["quotedByEmail"],
    quotedByName:
      json["quotedByName"] == null ? undefined : json["quotedByName"],
    manualQuoting:
      json["manualQuoting"] == null ? undefined : json["manualQuoting"],
    manualQuotingNotes:
      json["manualQuotingNotes"] == null
        ? undefined
        : json["manualQuotingNotes"],
    manualQuotingOpen:
      json["manualQuotingOpen"] == null ? undefined : json["manualQuotingOpen"],
    standardDryVanLinearFeet:
      json["standardDryVanLinearFeet"] == null
        ? undefined
        : json["standardDryVanLinearFeet"],
    freightMissing:
      json["freightMissing"] == null ? undefined : json["freightMissing"],
    apolloQuotingTriaged:
      json["apolloQuotingTriaged"] == null
        ? undefined
        : json["apolloQuotingTriaged"],
    equipmentType:
      json["equipmentType"] == null
        ? undefined
        : EquipmentTypeFromJSON(json["equipmentType"]),
    exclusiveUseNeeded:
      json["exclusiveUseNeeded"] == null
        ? undefined
        : json["exclusiveUseNeeded"],
    addInsuranceToShipment:
      json["addInsuranceToShipment"] == null
        ? undefined
        : json["addInsuranceToShipment"],
    insuranceAmount:
      json["insuranceAmount"] == null ? undefined : json["insuranceAmount"],
    insuranceCurrency:
      json["insuranceCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["insuranceCurrency"]),
    outForDeliveryDate:
      json["outForDeliveryDate"] == null
        ? undefined
        : json["outForDeliveryDate"],
    hotFreight: json["hotFreight"] == null ? undefined : json["hotFreight"],
    pickupPackageDocumentId:
      json["pickupPackageDocumentId"] == null
        ? undefined
        : json["pickupPackageDocumentId"],
    appointmentDate:
      json["appointmentDate"] == null ? undefined : json["appointmentDate"],
    apolloQuotingFlagged:
      json["apolloQuotingFlagged"] == null
        ? undefined
        : json["apolloQuotingFlagged"],
    freightMissingDate:
      json["freightMissingDate"] == null
        ? undefined
        : json["freightMissingDate"],
    challengeAllInvoices:
      json["challengeAllInvoices"] == null
        ? undefined
        : json["challengeAllInvoices"],
    branchId: json["branchId"] == null ? undefined : json["branchId"],
    tarpRequired:
      json["tarpRequired"] == null ? undefined : json["tarpRequired"],
    deliveryDeadline:
      json["deliveryDeadline"] == null ? undefined : json["deliveryDeadline"],
    carrierInvoicingClosed:
      json["carrierInvoicingClosed"] == null
        ? undefined
        : json["carrierInvoicingClosed"],
    pickupBoothNumber:
      json["pickupBoothNumber"] == null ? undefined : json["pickupBoothNumber"],
    deliveryBoothNumber:
      json["deliveryBoothNumber"] == null
        ? undefined
        : json["deliveryBoothNumber"],
    isPickupBooked:
      json["isPickupBooked"] == null ? undefined : json["isPickupBooked"],
    advanceInterlineProNumber:
      json["advanceInterlineProNumber"] == null
        ? undefined
        : json["advanceInterlineProNumber"],
    advanceInterlineCarrierPickupNumber:
      json["advanceInterlineCarrierPickupNumber"] == null
        ? undefined
        : json["advanceInterlineCarrierPickupNumber"],
    advanceInterlineCarrierIdentifier:
      json["advanceInterlineCarrierIdentifier"] == null
        ? undefined
        : json["advanceInterlineCarrierIdentifier"],
    advanceInterlineCarrierDisplayName:
      json["advanceInterlineCarrierDisplayName"] == null
        ? undefined
        : json["advanceInterlineCarrierDisplayName"],
    beyondInterlineProNumber:
      json["beyondInterlineProNumber"] == null
        ? undefined
        : json["beyondInterlineProNumber"],
    beyondInterlineCarrierPickupNumber:
      json["beyondInterlineCarrierPickupNumber"] == null
        ? undefined
        : json["beyondInterlineCarrierPickupNumber"],
    beyondInterlineCarrierIdentifier:
      json["beyondInterlineCarrierIdentifier"] == null
        ? undefined
        : json["beyondInterlineCarrierIdentifier"],
    beyondInterlineCarrierDisplayName:
      json["beyondInterlineCarrierDisplayName"] == null
        ? undefined
        : json["beyondInterlineCarrierDisplayName"],
    customDocsDeliveredAt:
      json["customDocsDeliveredAt"] == null
        ? undefined
        : json["customDocsDeliveredAt"],
    customDocsSentTo:
      json["customDocsSentTo"] == null ? undefined : json["customDocsSentTo"],
    pickupDeadline:
      json["pickupDeadline"] == null ? undefined : json["pickupDeadline"],
    problems: json["problems"] == null ? undefined : json["problems"],
    tags: json["tags"] == null ? undefined : json["tags"],
    invoiceAuditOpen:
      json["invoiceAuditOpen"] == null ? undefined : json["invoiceAuditOpen"],
    invoiceAuditAssignee:
      json["invoiceAuditAssignee"] == null
        ? undefined
        : json["invoiceAuditAssignee"],
    invoiceAuditExisted:
      json["invoiceAuditExisted"] == null
        ? undefined
        : json["invoiceAuditExisted"],
    invoiceAuditCustomerFrontConversationId:
      json["invoiceAuditCustomerFrontConversationId"] == null
        ? undefined
        : json["invoiceAuditCustomerFrontConversationId"],
    invoiceAuditCarrierFrontConversationId:
      json["invoiceAuditCarrierFrontConversationId"] == null
        ? undefined
        : json["invoiceAuditCarrierFrontConversationId"],
    invoiceAuditCarrierTurn:
      json["invoiceAuditCarrierTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["invoiceAuditCarrierTurn"]),
    invoiceAuditCustomerTurn:
      json["invoiceAuditCustomerTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["invoiceAuditCustomerTurn"]),
    invoiceAuditCarrierTurnTime:
      json["invoiceAuditCarrierTurnTime"] == null
        ? undefined
        : json["invoiceAuditCarrierTurnTime"],
    invoiceAuditCustomerTurnTime:
      json["invoiceAuditCustomerTurnTime"] == null
        ? undefined
        : json["invoiceAuditCustomerTurnTime"],
    invoiceAuditProblems:
      json["invoiceAuditProblems"] == null
        ? undefined
        : (json["invoiceAuditProblems"] as Array<any>).map(
            InvoiceAuditProblemFromJSON,
          ),
    invoiceAuditFirstOpenedDate:
      json["invoiceAuditFirstOpenedDate"] == null
        ? undefined
        : json["invoiceAuditFirstOpenedDate"],
    invoiceAuditSnoozedUntilDate:
      json["invoiceAuditSnoozedUntilDate"] == null
        ? undefined
        : json["invoiceAuditSnoozedUntilDate"],
    standardDryVanLinearFeetSvg:
      json["standardDryVanLinearFeetSvg"] == null
        ? undefined
        : json["standardDryVanLinearFeetSvg"],
    linearFeetOverride:
      json["linearFeetOverride"] == null
        ? undefined
        : json["linearFeetOverride"],
    pauseCustomsDocsReminders:
      json["pauseCustomsDocsReminders"] == null
        ? undefined
        : json["pauseCustomsDocsReminders"],
    onHoldReason:
      json["onHoldReason"] == null ? undefined : json["onHoldReason"],
    automaticallyFetchTrackingUpdates:
      json["automaticallyFetchTrackingUpdates"] == null
        ? undefined
        : json["automaticallyFetchTrackingUpdates"],
    pickupDayReminderEmailSent:
      json["pickupDayReminderEmailSent"] == null
        ? undefined
        : json["pickupDayReminderEmailSent"],
    source: json["source"] == null ? undefined : SourceFromJSON(json["source"]),
    provisionalXeroCarrierInvoiceId:
      json["provisionalXeroCarrierInvoiceId"] == null
        ? undefined
        : json["provisionalXeroCarrierInvoiceId"],
    missingInvoiceFrontConversationId:
      json["missingInvoiceFrontConversationId"] == null
        ? undefined
        : json["missingInvoiceFrontConversationId"],
    bannerMessageTitle:
      json["bannerMessageTitle"] == null
        ? undefined
        : json["bannerMessageTitle"],
    bannerMessageDescription:
      json["bannerMessageDescription"] == null
        ? undefined
        : json["bannerMessageDescription"],
    bannerMessageLastEditedBy:
      json["bannerMessageLastEditedBy"] == null
        ? undefined
        : json["bannerMessageLastEditedBy"],
    bannerMessageLastEditedAt:
      json["bannerMessageLastEditedAt"] == null
        ? undefined
        : json["bannerMessageLastEditedAt"],
    pendingCustomsClearance:
      json["pendingCustomsClearance"] == null
        ? undefined
        : json["pendingCustomsClearance"],
    stateOfGoods:
      json["stateOfGoods"] == null
        ? undefined
        : StateOfGoodsEnumFromJSON(json["stateOfGoods"]),
    pickupBookingMethod:
      json["pickupBookingMethod"] == null
        ? undefined
        : ShipmentPickupBookingMethodFromJSON(json["pickupBookingMethod"]),
    bookedAtAssignedTo:
      json["bookedAtAssignedTo"] == null
        ? undefined
        : json["bookedAtAssignedTo"],
    skipCustomerInvoiceNotification:
      json["skipCustomerInvoiceNotification"] == null
        ? undefined
        : json["skipCustomerInvoiceNotification"],
    pickupLocationHasDock:
      json["pickupLocationHasDock"] == null
        ? undefined
        : LoadingCapabilitiesAvailabilityFromJSON(
            json["pickupLocationHasDock"],
          ),
    pickupLocationHasForklift:
      json["pickupLocationHasForklift"] == null
        ? undefined
        : LoadingCapabilitiesAvailabilityFromJSON(
            json["pickupLocationHasForklift"],
          ),
    deliveryLocationHasDock:
      json["deliveryLocationHasDock"] == null
        ? undefined
        : LoadingCapabilitiesAvailabilityFromJSON(
            json["deliveryLocationHasDock"],
          ),
    deliveryLocationHasForklift:
      json["deliveryLocationHasForklift"] == null
        ? undefined
        : LoadingCapabilitiesAvailabilityFromJSON(
            json["deliveryLocationHasForklift"],
          ),
    externalMetadata:
      json["externalMetadata"] == null ? undefined : json["externalMetadata"],
    insuranceCertificate:
      json["insuranceCertificate"] == null
        ? undefined
        : json["insuranceCertificate"],
    insurancePremiumAmount:
      json["insurancePremiumAmount"] == null
        ? undefined
        : json["insurancePremiumAmount"],
    insurancePremiumTaxesAmount:
      json["insurancePremiumTaxesAmount"] == null
        ? undefined
        : json["insurancePremiumTaxesAmount"],
    insurancePremiumCurrency:
      json["insurancePremiumCurrency"] == null
        ? undefined
        : json["insurancePremiumCurrency"],
    insurancePremiumReferralReason:
      json["insurancePremiumReferralReason"] == null
        ? undefined
        : json["insurancePremiumReferralReason"],
    insuranceCommodityGroup:
      json["insuranceCommodityGroup"] == null
        ? undefined
        : json["insuranceCommodityGroup"],
    insuranceCertificateStatus:
      json["insuranceCertificateStatus"] == null
        ? undefined
        : json["insuranceCertificateStatus"],
    insuranceCertificateCreatedAt:
      json["insuranceCertificateCreatedAt"] == null
        ? undefined
        : json["insuranceCertificateCreatedAt"],
    bookedShipmentNumber:
      json["bookedShipmentNumber"] == null
        ? undefined
        : json["bookedShipmentNumber"],
    manualQuotingOpenedAt:
      json["manualQuotingOpenedAt"] == null
        ? undefined
        : json["manualQuotingOpenedAt"],
    invoiceAuditClosedAt:
      json["invoiceAuditClosedAt"] == null
        ? undefined
        : json["invoiceAuditClosedAt"],
    customsManuallyClearedAt:
      json["customsManuallyClearedAt"] == null
        ? undefined
        : json["customsManuallyClearedAt"],
    freightShortage:
      json["freightShortage"] == null ? undefined : json["freightShortage"],
    freightShortageDate:
      json["freightShortageDate"] == null
        ? undefined
        : json["freightShortageDate"],
    operationsAssignedTo:
      json["operationsAssignedTo"] == null
        ? undefined
        : json["operationsAssignedTo"],
    operationsAssignedAt:
      json["operationsAssignedAt"] == null
        ? undefined
        : json["operationsAssignedAt"],
    additionalNotificationEmails:
      json["additionalNotificationEmails"] == null
        ? undefined
        : json["additionalNotificationEmails"],
    freightDamaged:
      json["freightDamaged"] == null ? undefined : json["freightDamaged"],
    freightDamagedDate:
      json["freightDamagedDate"] == null
        ? undefined
        : json["freightDamagedDate"],
    operatorFlagged:
      json["operatorFlagged"] == null ? undefined : json["operatorFlagged"],
    operatorFlaggedAt:
      json["operatorFlaggedAt"] == null ? undefined : json["operatorFlaggedAt"],
    operatorFlaggedMessage:
      json["operatorFlaggedMessage"] == null
        ? undefined
        : json["operatorFlaggedMessage"],
    operatorFlaggedBy:
      json["operatorFlaggedBy"] == null ? undefined : json["operatorFlaggedBy"],
    operatorFlaggedByDisplayName:
      json["operatorFlaggedByDisplayName"] == null
        ? undefined
        : json["operatorFlaggedByDisplayName"],
    customerFlagged:
      json["customerFlagged"] == null ? undefined : json["customerFlagged"],
    customerFlaggedAt:
      json["customerFlaggedAt"] == null ? undefined : json["customerFlaggedAt"],
    customerFlaggedMessage:
      json["customerFlaggedMessage"] == null
        ? undefined
        : json["customerFlaggedMessage"],
    customerFlaggedBy:
      json["customerFlaggedBy"] == null ? undefined : json["customerFlaggedBy"],
    customerFlaggedByDisplayName:
      json["customerFlaggedByDisplayName"] == null
        ? undefined
        : json["customerFlaggedByDisplayName"],
    erapPlanNumber:
      json["erapPlanNumber"] == null ? undefined : json["erapPlanNumber"],
    erapPhoneNumber:
      json["erapPhoneNumber"] == null ? undefined : json["erapPhoneNumber"],
    tdgResponsibleName:
      json["tdgResponsibleName"] == null
        ? undefined
        : json["tdgResponsibleName"],
  };
}

export function ShipmentToJSON(json: any): Shipment {
  return ShipmentToJSONTyped(json, false);
}

export function ShipmentToJSONTyped(
  value?: Shipment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    createdAt: value["createdAt"],
    companyId: value["companyId"],
    createdBy: value["createdBy"],
    state: ShipmentStateToJSON(value["state"]),
    pickupDate: value["pickupDate"],
    expectedDeliveryDate: value["expectedDeliveryDate"],
    expectedDeliveryHours: value["expectedDeliveryHours"],
    actualDeliveryDate: value["actualDeliveryDate"],
    actualDeliveryTime: value["actualDeliveryTime"],
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    pickupContact: ContactToJSON(value["pickupContact"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
    deliveryContact: ContactToJSON(value["deliveryContact"]),
    lineItems:
      value["lineItems"] == null
        ? undefined
        : (value["lineItems"] as Array<any>).map(LineItemToJSON),
    stripePaymentMethodId: value["stripePaymentMethodId"],
    selectedQuoteId: value["selectedQuoteId"],
    billOfLadingDocumentId: value["billOfLadingDocumentId"],
    proNumber: value["proNumber"],
    carrierPickupNumber: value["carrierPickupNumber"],
    pickupReferenceNumber: value["pickupReferenceNumber"],
    deliveryReferenceNumber: value["deliveryReferenceNumber"],
    cancellationRequested: value["cancellationRequested"],
    deleted: value["deleted"],
    bookedAt: value["bookedAt"],
    trackingId: value["trackingId"],
    broker: BrokerToJSON(value["broker"]),
    isReviewingPriorToBooking: value["isReviewingPriorToBooking"],
    deletionReason: value["deletionReason"],
    emergencyContactName: value["emergencyContactName"],
    emergencyContactPhoneNumber: value["emergencyContactPhoneNumber"],
    emergencyContactPhoneNumberExtension:
      value["emergencyContactPhoneNumberExtension"],
    customsDocsState: CustomsDocsStateToJSON(value["customsDocsState"]),
    expectedDeliveryDateFromApi: value["expectedDeliveryDateFromApi"],
    billOfLadingNumber: value["billOfLadingNumber"],
    finalizeBookingStages: value["finalizeBookingStages"],
    deliveryAppointmentMade: value["deliveryAppointmentMade"],
    deliveryAppointmentHours: value["deliveryAppointmentHours"],
    outForDelivery: value["outForDelivery"],
    late: value["late"],
    numberDaysLate: value["numberDaysLate"],
    originalPickupDate: value["originalPickupDate"],
    bookedBy: value["bookedBy"],
    totalWeight: value["totalWeight"],
    totalVolume: value["totalVolume"],
    density: value["density"],
    totalHandlingUnits: value["totalHandlingUnits"],
    declaredValue: value["declaredValue"],
    declaredValueCurrency: CurrencyCodeToJSON(value["declaredValueCurrency"]),
    suggestedTrackingLine: value["suggestedTrackingLine"],
    expectedDeliveryDateAtPickup: value["expectedDeliveryDateAtPickup"],
    latestPredictedDeliveryDateAtPickup:
      value["latestPredictedDeliveryDateAtPickup"],
    pauseAmyEmailsUntilDate: value["pauseAmyEmailsUntilDate"],
    shipmentHash: value["shipmentHash"],
    bookedByPhone: value["bookedByPhone"],
    bookedByEmail: value["bookedByEmail"],
    bookedByName: value["bookedByName"],
    quotedByPhone: value["quotedByPhone"],
    quotedByEmail: value["quotedByEmail"],
    quotedByName: value["quotedByName"],
    manualQuoting: value["manualQuoting"],
    manualQuotingNotes: value["manualQuotingNotes"],
    manualQuotingOpen: value["manualQuotingOpen"],
    standardDryVanLinearFeet: value["standardDryVanLinearFeet"],
    freightMissing: value["freightMissing"],
    apolloQuotingTriaged: value["apolloQuotingTriaged"],
    equipmentType: EquipmentTypeToJSON(value["equipmentType"]),
    exclusiveUseNeeded: value["exclusiveUseNeeded"],
    addInsuranceToShipment: value["addInsuranceToShipment"],
    insuranceAmount: value["insuranceAmount"],
    insuranceCurrency: CurrencyCodeToJSON(value["insuranceCurrency"]),
    outForDeliveryDate: value["outForDeliveryDate"],
    hotFreight: value["hotFreight"],
    pickupPackageDocumentId: value["pickupPackageDocumentId"],
    appointmentDate: value["appointmentDate"],
    apolloQuotingFlagged: value["apolloQuotingFlagged"],
    freightMissingDate: value["freightMissingDate"],
    challengeAllInvoices: value["challengeAllInvoices"],
    branchId: value["branchId"],
    tarpRequired: value["tarpRequired"],
    deliveryDeadline: value["deliveryDeadline"],
    carrierInvoicingClosed: value["carrierInvoicingClosed"],
    pickupBoothNumber: value["pickupBoothNumber"],
    deliveryBoothNumber: value["deliveryBoothNumber"],
    isPickupBooked: value["isPickupBooked"],
    advanceInterlineProNumber: value["advanceInterlineProNumber"],
    advanceInterlineCarrierPickupNumber:
      value["advanceInterlineCarrierPickupNumber"],
    advanceInterlineCarrierIdentifier:
      value["advanceInterlineCarrierIdentifier"],
    advanceInterlineCarrierDisplayName:
      value["advanceInterlineCarrierDisplayName"],
    beyondInterlineProNumber: value["beyondInterlineProNumber"],
    beyondInterlineCarrierPickupNumber:
      value["beyondInterlineCarrierPickupNumber"],
    beyondInterlineCarrierIdentifier: value["beyondInterlineCarrierIdentifier"],
    beyondInterlineCarrierDisplayName:
      value["beyondInterlineCarrierDisplayName"],
    customDocsDeliveredAt: value["customDocsDeliveredAt"],
    customDocsSentTo: value["customDocsSentTo"],
    pickupDeadline: value["pickupDeadline"],
    problems: value["problems"],
    tags: value["tags"],
    invoiceAuditOpen: value["invoiceAuditOpen"],
    invoiceAuditAssignee: value["invoiceAuditAssignee"],
    invoiceAuditExisted: value["invoiceAuditExisted"],
    invoiceAuditCustomerFrontConversationId:
      value["invoiceAuditCustomerFrontConversationId"],
    invoiceAuditCarrierFrontConversationId:
      value["invoiceAuditCarrierFrontConversationId"],
    invoiceAuditCarrierTurn: ConversationTurnToJSON(
      value["invoiceAuditCarrierTurn"],
    ),
    invoiceAuditCustomerTurn: ConversationTurnToJSON(
      value["invoiceAuditCustomerTurn"],
    ),
    invoiceAuditCarrierTurnTime: value["invoiceAuditCarrierTurnTime"],
    invoiceAuditCustomerTurnTime: value["invoiceAuditCustomerTurnTime"],
    invoiceAuditProblems:
      value["invoiceAuditProblems"] == null
        ? undefined
        : (value["invoiceAuditProblems"] as Array<any>).map(
            InvoiceAuditProblemToJSON,
          ),
    invoiceAuditFirstOpenedDate: value["invoiceAuditFirstOpenedDate"],
    invoiceAuditSnoozedUntilDate: value["invoiceAuditSnoozedUntilDate"],
    standardDryVanLinearFeetSvg: value["standardDryVanLinearFeetSvg"],
    linearFeetOverride: value["linearFeetOverride"],
    pauseCustomsDocsReminders: value["pauseCustomsDocsReminders"],
    onHoldReason: value["onHoldReason"],
    automaticallyFetchTrackingUpdates:
      value["automaticallyFetchTrackingUpdates"],
    pickupDayReminderEmailSent: value["pickupDayReminderEmailSent"],
    source: SourceToJSON(value["source"]),
    provisionalXeroCarrierInvoiceId: value["provisionalXeroCarrierInvoiceId"],
    missingInvoiceFrontConversationId:
      value["missingInvoiceFrontConversationId"],
    bannerMessageTitle: value["bannerMessageTitle"],
    bannerMessageDescription: value["bannerMessageDescription"],
    bannerMessageLastEditedBy: value["bannerMessageLastEditedBy"],
    bannerMessageLastEditedAt: value["bannerMessageLastEditedAt"],
    pendingCustomsClearance: value["pendingCustomsClearance"],
    stateOfGoods: StateOfGoodsEnumToJSON(value["stateOfGoods"]),
    pickupBookingMethod: ShipmentPickupBookingMethodToJSON(
      value["pickupBookingMethod"],
    ),
    bookedAtAssignedTo: value["bookedAtAssignedTo"],
    skipCustomerInvoiceNotification: value["skipCustomerInvoiceNotification"],
    pickupLocationHasDock: LoadingCapabilitiesAvailabilityToJSON(
      value["pickupLocationHasDock"],
    ),
    pickupLocationHasForklift: LoadingCapabilitiesAvailabilityToJSON(
      value["pickupLocationHasForklift"],
    ),
    deliveryLocationHasDock: LoadingCapabilitiesAvailabilityToJSON(
      value["deliveryLocationHasDock"],
    ),
    deliveryLocationHasForklift: LoadingCapabilitiesAvailabilityToJSON(
      value["deliveryLocationHasForklift"],
    ),
    externalMetadata: value["externalMetadata"],
    insuranceCertificate: value["insuranceCertificate"],
    insurancePremiumAmount: value["insurancePremiumAmount"],
    insurancePremiumTaxesAmount: value["insurancePremiumTaxesAmount"],
    insurancePremiumCurrency: value["insurancePremiumCurrency"],
    insurancePremiumReferralReason: value["insurancePremiumReferralReason"],
    insuranceCommodityGroup: value["insuranceCommodityGroup"],
    insuranceCertificateStatus: value["insuranceCertificateStatus"],
    insuranceCertificateCreatedAt: value["insuranceCertificateCreatedAt"],
    bookedShipmentNumber: value["bookedShipmentNumber"],
    manualQuotingOpenedAt: value["manualQuotingOpenedAt"],
    invoiceAuditClosedAt: value["invoiceAuditClosedAt"],
    customsManuallyClearedAt: value["customsManuallyClearedAt"],
    freightShortage: value["freightShortage"],
    freightShortageDate: value["freightShortageDate"],
    operationsAssignedTo: value["operationsAssignedTo"],
    operationsAssignedAt: value["operationsAssignedAt"],
    additionalNotificationEmails: value["additionalNotificationEmails"],
    freightDamaged: value["freightDamaged"],
    freightDamagedDate: value["freightDamagedDate"],
    operatorFlagged: value["operatorFlagged"],
    operatorFlaggedAt: value["operatorFlaggedAt"],
    operatorFlaggedMessage: value["operatorFlaggedMessage"],
    operatorFlaggedBy: value["operatorFlaggedBy"],
    operatorFlaggedByDisplayName: value["operatorFlaggedByDisplayName"],
    customerFlagged: value["customerFlagged"],
    customerFlaggedAt: value["customerFlaggedAt"],
    customerFlaggedMessage: value["customerFlaggedMessage"],
    customerFlaggedBy: value["customerFlaggedBy"],
    customerFlaggedByDisplayName: value["customerFlaggedByDisplayName"],
    erapPlanNumber: value["erapPlanNumber"],
    erapPhoneNumber: value["erapPhoneNumber"],
    tdgResponsibleName: value["tdgResponsibleName"],
  };
}
